function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgHkd = function SvgHkd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("circle", {
    style: {
      fill: "#D80027"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M282.43,193.668c-5.818,24.199-16.155,19.584-21.228,40.688 c-29.883-7.185-48.287-37.235-41.102-67.12c7.182-29.883,37.235-48.287,67.119-41.102 C277.072,168.341,287.635,172.025,282.43,193.668z"
  }), React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M204.887,211.6c21.217,13.01,13.633,21.417,32.135,32.764 c-16.068,26.201-50.333,34.416-76.535,18.349c-26.201-16.067-34.418-50.334-18.35-76.535 C179.143,208.87,185.908,199.963,204.887,211.6z"
  }), React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M197.978,290.892c18.931-16.158,24.58-6.348,41.089-20.438c19.955,23.377,17.179,58.505-6.197,78.46 c-23.378,19.955-58.506,17.176-78.458-6.199C187.426,314.532,181.045,305.343,197.978,290.892z"
  }), React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M271.254,321.965c-9.52-22.997,1.556-25.341-6.743-45.394c28.399-11.753,60.951,1.741,72.705,30.14 c11.753,28.399-1.743,60.95-30.142,72.704C290.477,339.306,279.768,342.535,271.254,321.965z"
  }), React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M323.45,261.876c-24.813,1.947-23.622-9.313-45.257-7.615c-2.403-30.639,20.491-57.43,51.132-59.835 c30.64-2.399,57.43,20.493,59.832,51.135C345.88,248.954,345.641,260.137,323.45,261.876z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHkd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/HKD.f4509161.svg";
export { ForwardRef as ReactComponent };